<template>
  <div class="msgInput">
    <div class="quotePreview" v-if="quoteTarget">
      <span class="quotePreviewText">回覆 {{ quoteTarget.userName }}：{{ quoteTarget.text }}</span>
      <a class="quotePreviewCancel" @click="cancelQuote">✕</a>
    </div>
    <textarea
      ref="messageInput"
      name="message-to-send"
      id="message-to-send"
      :placeholder="placeholder"
      rows="3"
      v-model="inputtext"
      @input="input"
      @keydown.prevent.enter="keyenter"
      :disabled="disabled"
    ></textarea>
    <div class="msgSend">
      <img src="../../../static/img/msgSend-icon.png" alt @click="send" />
    </div>
  </div>
</template>


<script>
import Global from "@/components/Global";
import { MessageInputHandler } from "../../handler/MessageInputHandler.js";
import store from "@/vuex/store_chat.js";
// 聊天室訊息輸入
export default {
  name: "ChatMessageInput",
  components: {},
  props: ["roomInfo"],
  data() {
    return {
      inputvalue: "",
      inputtext: "",
      placeholder: ""
    };
  },
  created() {},
  computed: {
    quoteTarget() {
      return store.state.quoteTarget;
    },
    disabled() {
      if (this.roomInfo.UserProfile != null) {
        switch (this.roomInfo.UserProfile.FollowStatus) {
          case 1:
            this.placeholder = "已封鎖官方帳號";
            return true;
            break;
          case 2:
            this.placeholder = "未加入OA";
            return true;
            break;
        }
      }
      var flag = store.state.reload;

      var speaker = store.state.speaker;
      var isspeaker = speaker.indexOf(Global.current_staffid) >= 0;
      if (isspeaker) {
        this.placeholder = "Type your message";
        return false;
      } else {
        this.placeholder = "No Permission";
        return true;
      }
    }
  },
  methods: {
    input: function(val) {
      if (this.inputtext != this.inputvalue) {
        this.inputvalue = this.inputtext;
      }
    },
    cancelQuote: function() {
      store.dispatch("SetQuoteTarget", null);
    },
    send: function() {
      if (this.inputvalue.trim().length == 0) {
        return;
      }

      if (this.inputvalue.substr(this.inputvalue.length - 1, 1) == "\n") {
        this.inputvalue = this.inputvalue.substr(0, this.inputvalue.length - 1);
      }

      MessageInputHandler.submitMessage(
        this.inputvalue,
        this.quoteTarget ? this.quoteTarget.messageId : null
      );
      this.cancelQuote();
      this.inputtext = "";
      this.inputvalue = "";
    },
    keyenter(event) {
      if ($("#message-to-send").val() != this.inputvalue) {
        return;
      }            

      
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);            

      if (event.shiftKey || (isMobile && event.key === "Enter")) {  // shift, 或者手機上按 Enter 鍵, 當成換行, 不送出訊息
        this.inputtext += "\n";
        return;
      } else {
        event.preventDefault();
      }

      if (this.inputvalue.trim().length == 0) {
        return;
      }

      if (this.inputvalue.substr(this.inputvalue.length - 1, 1) == "\n") {
        this.inputvalue = this.inputvalue.substr(0, this.inputvalue.length - 1);
      }
      MessageInputHandler.submitMessage(
        this.inputvalue,
        this.quoteTarget ? this.quoteTarget.messageId : null
      );
      this.cancelQuote();
      this.inputtext = "";
      this.inputvalue = "";
    }
  }
};
</script>
<style>
.msgInput .quotePreview {
  display: flex;
  align-items: center;
  background: #f2f2f2;
  border-left: 3px solid #409eff;
  padding: 4px 8px;
  font-size: 12px;
  color: #666;
}
.msgInput .quotePreviewText {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.msgInput .quotePreviewCancel {
  margin-left: 8px;
  cursor: pointer;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatMessageInput.vue